function notFound(param) {
  console.error('webview - jscoreEvent - notFoundEvent', param);
}

export default {
  notFound
};
